module.exports = __webpack_public_path__ + "static/media/ms-mobile-logo.899cca6d.svg";